import { createFileRoute } from '@tanstack/react-router'
import GeneralSettings from '@/pages/settings/general'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <GeneralSettings />
}
